<template>
<div v-if="authStatus.restoringSession || authStatus.loggingIn || redirecting">
	<v-dialog
	v-model="dialogue"
	width="300px"
	hide-overlay
	>
		<v-card
			color="primary"
			dark
		>
			<v-card-text>
			<template v-if="authStatus.restoringSession">
				Restoring session …
			</template>
			<template v-else-if="authStatus.loggingIn">
				Logging in …
			</template>
			<template v-else-if="redirecting">
				Redirecting …
			</template>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
			</v-card-text>
		</v-card>

	</v-dialog>
</div>
<div v-else-if="!authStatus.loggedIn">
	<v-dialog v-model="dialogue" persistent width="800px">
		<v-card>
			<v-card-title class="headline">
				Please login
			</v-card-title>
			<v-container>
				<v-layout row wrap>
					<v-flex xs12>
						<v-text-field
							prepend-icon="fa-user"
							placeholder="User handle or email address"
							v-model="credentials.user"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							:append-icon="showPwd ? 'fa-eye-slash' : 'fa-eye'"
							@click:append="showPwd = !showPwd"
							:type="showPwd ? 'text' : 'password'"
							prepend-icon="fa-key"
							placeholder="Password"
							v-model="credentials.password"
						></v-text-field>
					</v-flex>
				</v-layout>
			</v-container>
				<v-card-actions>
					<v-btn flat>Register</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat color="primary" @click="submit">Login</v-btn>
				</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmLogin",

	data () {
		return {
			dialogue: true,
			credentials: {
				user: null,
				password: null
			},
			showPwd: false,
			redirecting: false
		};
	},

	watch: {
		authStatus (newValue, oldValue) {
			if (newValue.restoringSession) {
			} else if (newValue.loggedIn) {
				this.maybeRedirect();
			}
		}
	},

	computed: {
		...Vuex.mapState({auth: "user"}),

		formValid () {
			return this.credentials.user && this.credentials.password;
		},

		authStatus () {
			return this.auth.status;
		},

		loggingIn () {
			return this.authStatus.loggingIn;
		}
	},

	methods: {
		...Vuex.mapActions([ "login" ]),

		async submit () {
			await this.login(this.credentials);
			this.maybeRedirect();
		},

		maybeRedirect () {
			if (this.auth.status.loggedIn) {
				this.redirecting = true;
				if (this.$route.query.redirect) {
					this.$router.replace(this.$route.query.redirect);
				} else {
					this.$router.replace("/");
				}
				this.dialogue = false;
				this.redirecting = false;
			}
		}
	},

	created () {
		this.maybeRedirect();
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue